import * as React from "react";
// import NotFoundPageComponent from "components/not-found-page";
import NotFoundPageComponent from "components/the-buzz-theme/page/main";

import { FontsCircular } from "lib/scripts";

function NotFoundPage() {
  return (
    <>
      <FontsCircular />
      <NotFoundPageComponent notFound={true} />
      {/* <NotFoundPageComponent /> */}
      {/* <NotFoundPageComponent code={404} /> */}
    </>
  );
}

export default NotFoundPage;
